import Request from '../../request';
const BASE_URI_GO_API = process.env.API_GO_URL + '/api/v1';

const GetInvestor = async (userId) => {
    return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/investidor/userId/${userId}`)
}

const GetReservaPendente = async (id) => {
    return await Request.AxiosAuthGet(`${BASE_URI_GO_API}/reserva/investidorId/${id}`)
}

export default {GetInvestor, GetReservaPendente}


// WEBPACK FOOTER //
// ./src/services/api/investor/index.js